module.exports = __webpack_public_path__ + "static/media/jamie-street-94244-unsplash.1ff059b8.jpg";